import { apolloClient } from '@aps-management/primapp-common';
import { v4 as uuidv4 } from 'uuid';

import store from '_config/store';

function getContext() {
  const context = {};
  const { golf, token } = store.getState().app;
  if (golf) context.golfId = golf.id;
  if (token) context.accessToken = token;
  // Cf. masterClient.js : en-tête de corrélation recopié par le lien Apollo de
  // primapp-common. Un id par requête HTTP.
  context.headers = { 'x-request-id': uuidv4() };
  return context;
}

/* */
const client = {
  /* */
  query: ({ query, variables, fetchPolicy, errorPolicy }) =>
    apolloClient.query({
      query,
      variables,
      fetchPolicy,
      errorPolicy,
      context: getContext(),
    }),
  /* */
  mutate: ({ mutation, variables, errorPolicy }) =>
    apolloClient.mutate({
      mutation,
      variables,
      errorPolicy,
      context: getContext(),
    }),
};

export default client;
